<div class="recurrence-form" [class.disabled]="disabled">

    <div class="row">
        <p class="row-label">{{ "recurrence.typeSection" | translate }}:</p>
        <div class="row-value">
            <div class="type-choices">
                <label class="chip" [class.on]="type === types.DAILY">
                    <input type="radio" name="recurrenceType"
                           [checked]="type === types.DAILY"
                           [disabled]="disabled"
                           (change)="selectType(types.DAILY)" />
                    <span>{{ "recurrence.type.daily" | translate }}</span>
                </label>
                <label class="chip" [class.on]="type === types.WEEKLY">
                    <input type="radio" name="recurrenceType"
                           [checked]="type === types.WEEKLY"
                           [disabled]="disabled"
                           (change)="selectType(types.WEEKLY)" />
                    <span>{{ "recurrence.type.weekly" | translate }}</span>
                </label>
                <label class="chip" [class.on]="type === types.MONTHLY">
                    <input type="radio" name="recurrenceType"
                           [checked]="type === types.MONTHLY"
                           [disabled]="disabled"
                           (change)="selectType(types.MONTHLY)" />
                    <span>{{ "recurrence.type.monthly" | translate }}</span>
                </label>
                <label class="chip" [class.on]="type === types.YEARLY">
                    <input type="radio" name="recurrenceType"
                           [checked]="type === types.YEARLY"
                           [disabled]="disabled"
                           (change)="selectType(types.YEARLY)" />
                    <span>{{ "recurrence.type.yearly" | translate }}</span>
                </label>
            </div>
        </div>
    </div>

    <div class="row">
        <p class="row-label">{{ "recurrence.patternSection" | translate }}:</p>
        <div class="row-value">
            <div class="type-detail">

                <ng-container *ngIf="type === types.DAILY">
                    <label class="radio inline">
                        <input type="radio" name="dailyKind"
                               [checked]="!pattern.everyWeekday"
                               [disabled]="disabled"
                               (change)="setEveryWeekday(false)" />
                        <span>{{ "recurrence.daily.everyN" | translate }}</span>
                        <input class="number" type="number" min="1"
                               [value]="pattern.interval"
                               [disabled]="disabled || pattern.everyWeekday"
                               (input)="setInterval($any($event.target).value)" />
                        <span>{{ "recurrence.daily.days" | translate }}</span>
                    </label>
                    <label class="radio inline">
                        <input type="radio" name="dailyKind"
                               [checked]="pattern.everyWeekday"
                               [disabled]="disabled"
                               (change)="setEveryWeekday(true)" />
                        <span>{{ "recurrence.daily.everyWeekday" | translate }}</span>
                    </label>
                </ng-container>

                <ng-container *ngIf="type === types.WEEKLY">
                    <div class="inline">
                        <span>{{ "recurrence.weekly.everyN" | translate }}</span>
                        <input class="number" type="number" min="1"
                               [value]="pattern.interval"
                               [disabled]="disabled"
                               (input)="setInterval($any($event.target).value)" />
                        <span>{{ "recurrence.weekly.weeks" | translate }}</span>
                    </div>
                    <div class="weekday-grid">
                        <label class="chip day" *ngFor="let day of weekdays"
                               [class.on]="hasWeekday(day.day)">
                            <input type="checkbox"
                                   [checked]="hasWeekday(day.day)"
                                   [disabled]="disabled"
                                   (change)="toggleWeekday(day.day, $any($event.target).checked)" />
                            <span>{{ "recurrence.weekdayShort." + day.key | translate }}</span>
                        </label>
                    </div>
                </ng-container>

                <ng-container *ngIf="type === types.MONTHLY">
                    <label class="radio inline">
                        <input type="radio" name="monthlyKind"
                               [checked]="!useOrdinal"
                               [disabled]="disabled"
                               (change)="setUseOrdinal(false)" />
                        <span>{{ "recurrence.monthly.onDay" | translate }}</span>
                        <input class="number" type="number" min="1" max="31"
                               [value]="pattern.monthDay"
                               [disabled]="disabled || useOrdinal"
                               (input)="setMonthDay($any($event.target).value)" />
                        <span>{{ "recurrence.monthly.ofEveryN" | translate }}</span>
                        <input class="number" type="number" min="1"
                               [value]="pattern.interval"
                               [disabled]="disabled || useOrdinal"
                               (input)="setInterval($any($event.target).value)" />
                        <span>{{ "recurrence.monthly.months" | translate }}</span>
                    </label>

                    <label class="radio inline">
                        <input type="radio" name="monthlyKind"
                               [checked]="useOrdinal"
                               [disabled]="disabled"
                               (change)="setUseOrdinal(true)" />
                        <span>{{ "recurrence.monthly.onThe" | translate }}</span>
                        <select [value]="pattern.monthOrdinal"
                                [disabled]="disabled || !useOrdinal"
                                (change)="setMonthOrdinal($any($event.target).value)">
                            <option *ngFor="let one of ordinals" [value]="one.value"
                                    [selected]="one.value === pattern.monthOrdinal">
                                {{ "recurrence.ordinal." + one.key | translate }}
                            </option>
                        </select>
                        <select [value]="pattern.monthWeekday"
                                [disabled]="disabled || !useOrdinal"
                                (change)="setMonthWeekday($any($event.target).value)">
                            <option *ngFor="let day of weekdays" [value]="day.day"
                                    [selected]="day.day === pattern.monthWeekday">
                                {{ "recurrence.weekday." + day.key | translate }}
                            </option>
                        </select>
                        <span>{{ "recurrence.monthly.ofEveryNOrdinal" | translate }}</span>
                        <input class="number" type="number" min="1"
                               [value]="pattern.interval"
                               [disabled]="disabled || !useOrdinal"
                               (input)="setInterval($any($event.target).value)" />
                        <span>{{ "recurrence.monthly.months" | translate }}</span>
                    </label>
                </ng-container>

                <ng-container *ngIf="type === types.YEARLY">
                    <label class="radio inline">
                        <input type="radio" name="yearlyKind"
                               [checked]="!useOrdinal"
                               [disabled]="disabled"
                               (change)="setUseOrdinal(false)" />
                        <span>{{ "recurrence.yearly.onEvery" | translate }}</span>
                        <input class="number" type="number" min="1" max="31"
                               [value]="pattern.monthDay"
                               [disabled]="disabled || useOrdinal"
                               (input)="setMonthDay($any($event.target).value)" />
                        <select [value]="pattern.yearMonth"
                                [disabled]="disabled || useOrdinal"
                                (change)="setYearMonth($any($event.target).value)">
                            <option *ngFor="let month of months" [value]="month"
                                    [selected]="month === pattern.yearMonth">
                                {{ "recurrence.month." + month | translate }}
                            </option>
                        </select>
                    </label>

                    <label class="radio inline">
                        <input type="radio" name="yearlyKind"
                               [checked]="useOrdinal"
                               [disabled]="disabled"
                               (change)="setUseOrdinal(true)" />
                        <span>{{ "recurrence.yearly.onThe" | translate }}</span>
                        <select [value]="pattern.monthOrdinal"
                                [disabled]="disabled || !useOrdinal"
                                (change)="setMonthOrdinal($any($event.target).value)">
                            <option *ngFor="let one of ordinals" [value]="one.value"
                                    [selected]="one.value === pattern.monthOrdinal">
                                {{ "recurrence.ordinal." + one.key | translate }}
                            </option>
                        </select>
                        <select [value]="pattern.monthWeekday"
                                [disabled]="disabled || !useOrdinal"
                                (change)="setMonthWeekday($any($event.target).value)">
                            <option *ngFor="let day of weekdays" [value]="day.day"
                                    [selected]="day.day === pattern.monthWeekday">
                                {{ "recurrence.weekday." + day.key | translate }}
                            </option>
                        </select>
                        <span>{{ "recurrence.yearly.of" | translate }}</span>
                        <select [value]="pattern.yearMonth"
                                [disabled]="disabled || !useOrdinal"
                                (change)="setYearMonth($any($event.target).value)">
                            <option *ngFor="let month of months" [value]="month"
                                    [selected]="month === pattern.yearMonth">
                                {{ "recurrence.month." + month | translate }}
                            </option>
                        </select>
                    </label>
                </ng-container>

            </div>
        </div>
    </div>

    <div class="row">
        <p class="row-label">{{ "recurrence.range.start" | translate }}:</p>
        <div class="row-value">
            <input type="date"
                   [value]="pattern.startDate"
                   [disabled]="disabled"
                   (change)="setStartDate($any($event.target).value)" />
        </div>
    </div>

    <div class="row">
        <p class="row-label">{{ "recurrence.range.end" | translate }}:</p>
        <div class="row-value">
            <div class="range-end">
                <label class="radio inline">
                    <input type="radio" name="recurrenceEnd"
                           [checked]="pattern.endType === ends.ON_DATE"
                           [disabled]="disabled"
                           (change)="selectEndType(ends.ON_DATE)" />
                    <span>{{ "recurrence.range.endsOn" | translate }}:</span>
                    <input type="date"
                           [value]="pattern.endDate"
                           [disabled]="disabled || pattern.endType !== ends.ON_DATE"
                           (change)="setEndDate($any($event.target).value)" />
                </label>

                <label class="radio inline">
                    <input type="radio" name="recurrenceEnd"
                           [checked]="pattern.endType === ends.AFTER_COUNT"
                           [disabled]="disabled"
                           (change)="selectEndType(ends.AFTER_COUNT)" />
                    <span>{{ "recurrence.range.endsAfter" | translate }}:</span>
                    <input class="number" type="number" min="1"
                           [value]="pattern.endCount"
                           [disabled]="disabled || pattern.endType !== ends.AFTER_COUNT"
                           (input)="setEndCount($any($event.target).value)" />
                    <span>{{ "recurrence.range.times" | translate }}</span>
                </label>

                <label class="radio inline">
                    <input type="radio" name="recurrenceEnd"
                           [checked]="pattern.endType === ends.NEVER"
                           [disabled]="disabled"
                           (change)="selectEndType(ends.NEVER)" />
                    <span>{{ "recurrence.range.noEndDate" | translate }}</span>
                </label>
            </div>
        </div>
    </div>

    <ul class="recurrence-problems" *ngIf="showProblems">
        <li *ngFor="let problem of problems">{{ problem | translate }}</li>
    </ul>

</div>
